import { TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { useStyles } from '../OrionRequestForm/orionFormStyles';
import { amlCIFormValueTypes } from './amlCIFormValueTypes';
import { forwardRef, ReactNode, RefObject } from 'react';

type Props = {
  fieldPropName: keyof amlCIFormValueTypes;
  label: string;
  placeholder: string;
  required?: boolean;
  children: ReactNode;
};

type Ref = ((instance: HTMLDivElement | null) => void) | RefObject<HTMLDivElement> | null | undefined;

export const AMLCIFormDropdown = forwardRef(
  ({ fieldPropName, label, placeholder, required, children }: Props, ref?: Ref) => {
    const classes = useStyles();
    const formik = useFormikContext<amlCIFormValueTypes>();

    return (
      <TextField
        ref={ref}
        id={fieldPropName}
        key={fieldPropName}
        required={required}
        label={label}
        {...formik.getFieldProps(fieldPropName)}
        placeholder={placeholder}
        variant="outlined"
        select
        error={Boolean(formik.errors[fieldPropName] && formik.touched[fieldPropName])}
        className={classes.componentFormGroup}
      >
        {children}
      </TextField>
    );
  },
);
